export const getNameFromAWSLink = (link: string) => {
  const array = link.split(".com/");
  return array[1];
};
